export function formProductUrl(
  collectionName,
  categorySlug,
  spaceSlug,
  productSlug
) {
  switch (collectionName) {
    case "category":
      return `collections/${categorySlug}/products/${productSlug}`; // Regular category product URL
    case "spaces":
      return `spaces/${categorySlug}/products/${productSlug}`; // Space category product URL
    case "setup":
      return `spaces/${spaceSlug}/setup/${categorySlug}/products/${productSlug}`; // Setup category product URL
    default:
      return productSlug; // Fallback to product slug if no collection/space/setup name matches
  }
}
